export default __webpack_public_path__ + "static/media/458.445f2ae8.jpg";